import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { getEnvironment } from '../../../../shared/utils/helpers';

const BatchRestoreReviewAssetsMutation = input =>
  new Promise((resolve, reject) => {
    commitMutation(getEnvironment(), {
      mutation: graphql`
        mutation BatchRestoreReviewAssetsMutation($input: RestoreBatchReviewAssetsInput!) {
          restoreBatchReviewAssets(input: $input) {
            isRestoring
          }
        }
      `,
      variables: { input },
      onCompleted: resolve,
      onError: reject
    });
  });

export default BatchRestoreReviewAssetsMutation;
